import React from "react";
import { MessagesSquare } from "lucide-react";
import { Users } from "lucide-react";
import { BadgeCheck } from "lucide-react";

export default function WhyChooseUs() {
  return (
    <section className="bg-white flex flex-col font-inter justify-center m-0 px-4 py-12 sm:px-6 md:px-12 lg:px-16 xl:px-40">
      <div className="text-center text-3xl md:text-4xl font-medium text-heading-blue pb-12">
        Why Choose Us?
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 items-stretch">
        <div className="bg-brand-light rounded-[15px] flex transition-transform hover:scale-[1.02]">
          <div className="flex flex-col justify-center p-6 md:p-8 w-full">
            <div className="flex flex-col items-center justify-center pb-4">
              <div className="pb-6">
                <MessagesSquare size={40} className="text-heading-blue" />
              </div>
              <p className="text-xl md:text-2xl font-semibold text-center text-heading-blue">
                Bulk WhatsApp Broadcasting
              </p>
            </div>
            <div className="text-center text-slate-600 leading-relaxed">
              Elevate your brand’s reach with bulk messaging solutions. Amplify
              your product visibility and achieve outstanding results through
              targeted campaigns.
            </div>
          </div>
        </div>

        <div className="bg-brand-light rounded-[15px] flex transition-transform hover:scale-[1.02]">
          <div className="flex flex-col justify-center p-6 md:p-8 w-full">
            <div className="flex flex-col items-center justify-center pb-4">
              <div className="pb-6">
                <Users size={40} className="text-heading-blue" />
              </div>
              <p className="text-xl md:text-2xl font-semibold text-center text-heading-blue">
                Centralized Team Inbox
              </p>
            </div>
            <div className="text-center text-slate-600 leading-relaxed">
              Bring your team together with an intuitive inbox. Streamline
              communication, enhance collaboration, and ensure everyone stays
              connected.
            </div>
          </div>
        </div>

        <div className="bg-brand-light rounded-[15px] flex transition-transform hover:scale-[1.02]">
          <div className="flex flex-col justify-center p-6 md:p-8 w-full">
            <div className="flex flex-col items-center justify-center pb-4">
              <div className="pb-6">
                <BadgeCheck size={40} className="text-heading-blue" />
              </div>
              <p className="text-xl md:text-2xl font-semibold text-center text-heading-blue">
                Pre-Built Messaging Templates
              </p>
            </div>
            <div className="text-center text-slate-600 leading-relaxed">
              Streamline your communication with ready-to-use messaging
              templates. Save time, ensure consistency, and deliver professional
              messages tailored to your audience.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
